export const TOP = 'top';
export const RIGHT = 'right';
export const BOTTOM = 'bottom';
export const LEFT = 'left';

export const all = [TOP, RIGHT, BOTTOM, LEFT];

export type TooltipPosition = 'top' | 'right' | 'bottom' | 'left';
